import Image from 'next/image';
import React from 'react';
import { usePathname } from 'next/navigation';

const SocialLinks = ({ links }) => {
    const pathname = usePathname();

    return (
        <div
            className={`inline-flex w-full ${
                pathname.endsWith('contributions') ? 'justify-center' : ''
            } `}
        >
            {links?.github ? (
                <a
                    href={links.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center"
                >
                    <i className="ri-github-fill mx-0.5 md:mx-2 text-xl cursor-pointer"></i>
                </a>
            ) : null}

            {links?.linkedin ? (
                <a
                    href={links.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center"
                >
                    <i className="ri-linkedin-box-fill mx-0.5 md:mx-2 text-xl text-blue-800"></i>
                </a>
            ) : null}

            {links?.instagram ? (
                <a
                    href={links.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center"
                >
                    <i className="ri-instagram-line mx-0.5 md:mx-2 text-xl text-[#f4012f]"></i>
                </a>
            ) : null}

            {links?.facebook ? (
                <a
                    href={links.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center"
                >
                    <i className="ri-facebook-circle-fill mx-0.5 md:mx-2 text-xl text-blue-800"></i>
                </a>
            ) : null}

            {links?.frappeForum ? (
                <a
                    href={links.frappeForum}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center"
                >
                    <Image
                        src="/images/frappe-logo.png"
                        alt="frappe logo"
                        width={20}
                        height={20}
                    />
                </a>
            ) : null}
        </div>
    );
};

export default SocialLinks;
